import { Layout, theme } from 'antd';
import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSider from '../components/adminLayout/AdminSider';
import AdminBottomNav from '../components/adminLayout/AdminBottomNav';
import { getAdminLayoutCssVariables } from '../theme/adminLayoutTheme';
import { stripPathLanguage } from '../i18nLanguages';
import useLocalizedNavigate from '../hooks/useLocalizedNavigate';
import useIsMobile from '../hooks/useIsMobile';
import '../components/adminLayout/AdminLayout.css';

const { Content, Sider } = Layout;

const MainLayout = ({ fullPage }) => {
  const navigate = useLocalizedNavigate();
  const { token } = theme.useToken();
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(false);
  // The ticket page has its own bottom action bar; never two bottom bars.
  const showBottomNav =
    isMobile && !stripPathLanguage(pathname).startsWith('/job_repairs/edit');

  return (
    <Layout className="admin_layout" style={getAdminLayoutCssVariables(token)}>
      {!isMobile && (
        <Sider
          width={248}
          collapsedWidth={72}
          breakpoint="lg"
          collapsed={collapsed}
          onBreakpoint={(broken) => setCollapsed(broken)}
          className="admin_sider"
        >
          <AdminSider
            onSelect={navigate}
            collapsed={collapsed}
            onCollapse={() => setCollapsed((prev) => !prev)}
          />
        </Sider>
      )}

      <Layout className="admin_main">
        <Content className="admin_content">
          <Suspense fallback={null}>
            {fullPage ? (
              <Outlet />
            ) : (
              <div className="admin-layout-edit">
                <Outlet />
              </div>
            )}
          </Suspense>
        </Content>
        {showBottomNav && <AdminBottomNav onSelect={navigate} />}
      </Layout>
    </Layout>
  );
};

export default MainLayout;
